import { defineComponent as Se, ref as le, computed as ye, shallowRef as Et, onMounted as ot, toRaw as xe, watch as ne, toRefs as bt, onUnmounted as Tt, resolveComponent as At, createElementBlock as he, openBlock as ce, createCommentVNode as ve, createElementVNode as fe, toDisplayString as Ke, createVNode as Dt, normalizeClass as Me, createBlock as st, withCtx as Ot, createTextVNode as St, resolveDynamicComponent as Yt } from "vue";
import { v as Rt } from "./vsButton-BlFL21k0.mjs";
import * as de from "@turf/turf";
import { v as Lt } from "./v4-CPnJi9UN.mjs";
import { r as Xt } from "./index-9FD4Wxfy.mjs";
import { _ as Ye } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
import $t from "maplibre-gl";
const Ft = "data:image/svg+xml,%3csvg%20width='30'%20height='55'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='15'%20cy='15'%20r='15'%20fill='currentColor'/%3e%3ccircle%20cx='15'%20cy='15'%20r='5'%20fill='%23fff'/%3e%3cpath%20stroke='currentColor'%20stroke-width='2'%20d='M15%2030v25'/%3e%3c/svg%3e";
var lt = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: !0,
  timelineOffset: 0
}, Re = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
}, jt = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"], Ce = {
  CSS: {},
  springs: {}
};
function ie(e, t, a) {
  return Math.min(Math.max(e, t), a);
}
function pe(e, t) {
  return e.indexOf(t) > -1;
}
function be(e, t) {
  return e.apply(null, t);
}
var X = {
  arr: function(e) {
    return Array.isArray(e);
  },
  obj: function(e) {
    return pe(Object.prototype.toString.call(e), "Object");
  },
  pth: function(e) {
    return X.obj(e) && e.hasOwnProperty("totalLength");
  },
  svg: function(e) {
    return e instanceof SVGElement;
  },
  inp: function(e) {
    return e instanceof HTMLInputElement;
  },
  dom: function(e) {
    return e.nodeType || X.svg(e);
  },
  str: function(e) {
    return typeof e == "string";
  },
  fnc: function(e) {
    return typeof e == "function";
  },
  und: function(e) {
    return typeof e > "u";
  },
  nil: function(e) {
    return X.und(e) || e === null;
  },
  hex: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  rgb: function(e) {
    return /^rgb/.test(e);
  },
  hsl: function(e) {
    return /^hsl/.test(e);
  },
  col: function(e) {
    return X.hex(e) || X.rgb(e) || X.hsl(e);
  },
  key: function(e) {
    return !lt.hasOwnProperty(e) && !Re.hasOwnProperty(e) && e !== "targets" && e !== "keyframes";
  }
};
function ut(e) {
  var t = /\(([^)]+)\)/.exec(e);
  return t ? t[1].split(",").map(function(a) {
    return parseFloat(a);
  }) : [];
}
function ct(e, t) {
  var a = ut(e), r = ie(X.und(a[0]) ? 1 : a[0], 0.1, 100), o = ie(X.und(a[1]) ? 100 : a[1], 0.1, 100), f = ie(X.und(a[2]) ? 10 : a[2], 0.1, 100), d = ie(X.und(a[3]) ? 0 : a[3], 0.1, 100), M = Math.sqrt(o / r), l = f / (2 * Math.sqrt(o * r)), R = l < 1 ? M * Math.sqrt(1 - l * l) : 0, C = 1, w = l < 1 ? (l * M + -d) / R : -d + M;
  function S(D) {
    var T = t ? t * D / 1e3 : D;
    return l < 1 ? T = Math.exp(-T * l * M) * (C * Math.cos(R * T) + w * Math.sin(R * T)) : T = (C + w * T) * Math.exp(-T * M), D === 0 || D === 1 ? D : 1 - T;
  }
  function N() {
    var D = Ce.springs[e];
    if (D)
      return D;
    for (var T = 1 / 6, z = 0, W = 0; ; )
      if (z += T, S(z) === 1) {
        if (W++, W >= 16)
          break;
      } else
        W = 0;
    var i = z * T * 1e3;
    return Ce.springs[e] = i, i;
  }
  return t ? S : N;
}
function zt(e) {
  return e === void 0 && (e = 10), function(t) {
    return Math.ceil(ie(t, 1e-6, 1) * e) * (1 / e);
  };
}
var Nt = function() {
  var e = 11, t = 1 / (e - 1);
  function a(C, w) {
    return 1 - 3 * w + 3 * C;
  }
  function r(C, w) {
    return 3 * w - 6 * C;
  }
  function o(C) {
    return 3 * C;
  }
  function f(C, w, S) {
    return ((a(w, S) * C + r(w, S)) * C + o(w)) * C;
  }
  function d(C, w, S) {
    return 3 * a(w, S) * C * C + 2 * r(w, S) * C + o(w);
  }
  function M(C, w, S, N, D) {
    var T, z, W = 0;
    do
      z = w + (S - w) / 2, T = f(z, N, D) - C, T > 0 ? S = z : w = z;
    while (Math.abs(T) > 1e-7 && ++W < 10);
    return z;
  }
  function l(C, w, S, N) {
    for (var D = 0; D < 4; ++D) {
      var T = d(w, S, N);
      if (T === 0)
        return w;
      var z = f(w, S, N) - C;
      w -= z / T;
    }
    return w;
  }
  function R(C, w, S, N) {
    if (!(0 <= C && C <= 1 && 0 <= S && S <= 1))
      return;
    var D = new Float32Array(e);
    if (C !== w || S !== N)
      for (var T = 0; T < e; ++T)
        D[T] = f(T * t, C, S);
    function z(W) {
      for (var i = 0, s = 1, n = e - 1; s !== n && D[s] <= W; ++s)
        i += t;
      --s;
      var c = (W - D[s]) / (D[s + 1] - D[s]), u = i + c * t, h = d(u, C, S);
      return h >= 1e-3 ? l(W, u, C, S) : h === 0 ? u : M(W, i, i + t, C, S);
    }
    return function(W) {
      return C === w && S === N || W === 0 || W === 1 ? W : f(z(W), w, N);
    };
  }
  return R;
}(), ft = function() {
  var e = { linear: function() {
    return function(r) {
      return r;
    };
  } }, t = {
    Sine: function() {
      return function(r) {
        return 1 - Math.cos(r * Math.PI / 2);
      };
    },
    Expo: function() {
      return function(r) {
        return r ? Math.pow(2, 10 * r - 10) : 0;
      };
    },
    Circ: function() {
      return function(r) {
        return 1 - Math.sqrt(1 - r * r);
      };
    },
    Back: function() {
      return function(r) {
        return r * r * (3 * r - 2);
      };
    },
    Bounce: function() {
      return function(r) {
        for (var o, f = 4; r < ((o = Math.pow(2, --f)) - 1) / 11; )
          ;
        return 1 / Math.pow(4, 3 - f) - 7.5625 * Math.pow((o * 3 - 2) / 22 - r, 2);
      };
    },
    Elastic: function(r, o) {
      r === void 0 && (r = 1), o === void 0 && (o = 0.5);
      var f = ie(r, 1, 10), d = ie(o, 0.1, 2);
      return function(M) {
        return M === 0 || M === 1 ? M : -f * Math.pow(2, 10 * (M - 1)) * Math.sin((M - 1 - d / (Math.PI * 2) * Math.asin(1 / f)) * (Math.PI * 2) / d);
      };
    }
  }, a = ["Quad", "Cubic", "Quart", "Quint"];
  return a.forEach(function(r, o) {
    t[r] = function() {
      return function(f) {
        return Math.pow(f, o + 2);
      };
    };
  }), Object.keys(t).forEach(function(r) {
    var o = t[r];
    e["easeIn" + r] = o, e["easeOut" + r] = function(f, d) {
      return function(M) {
        return 1 - o(f, d)(1 - M);
      };
    }, e["easeInOut" + r] = function(f, d) {
      return function(M) {
        return M < 0.5 ? o(f, d)(M * 2) / 2 : 1 - o(f, d)(M * -2 + 2) / 2;
      };
    }, e["easeOutIn" + r] = function(f, d) {
      return function(M) {
        return M < 0.5 ? (1 - o(f, d)(1 - M * 2)) / 2 : (o(f, d)(M * 2 - 1) + 1) / 2;
      };
    };
  }), e;
}();
function Le(e, t) {
  if (X.fnc(e))
    return e;
  var a = e.split("(")[0], r = ft[a], o = ut(e);
  switch (a) {
    case "spring":
      return ct(e, t);
    case "cubicBezier":
      return be(Nt, o);
    case "steps":
      return be(zt, o);
    default:
      return be(r, o);
  }
}
function dt(e) {
  try {
    var t = document.querySelectorAll(e);
    return t;
  } catch {
    return;
  }
}
function Pe(e, t) {
  for (var a = e.length, r = arguments.length >= 2 ? arguments[1] : void 0, o = [], f = 0; f < a; f++)
    if (f in e) {
      var d = e[f];
      t.call(r, d, f, e) && o.push(d);
    }
  return o;
}
function Ie(e) {
  return e.reduce(function(t, a) {
    return t.concat(X.arr(a) ? Ie(a) : a);
  }, []);
}
function He(e) {
  return X.arr(e) ? e : (X.str(e) && (e = dt(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
}
function Xe(e, t) {
  return e.some(function(a) {
    return a === t;
  });
}
function $e(e) {
  var t = {};
  for (var a in e)
    t[a] = e[a];
  return t;
}
function De(e, t) {
  var a = $e(e);
  for (var r in e)
    a[r] = t.hasOwnProperty(r) ? t[r] : e[r];
  return a;
}
function Be(e, t) {
  var a = $e(e);
  for (var r in t)
    a[r] = X.und(e[r]) ? t[r] : e[r];
  return a;
}
function qt(e) {
  var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e);
  return t ? "rgba(" + t[1] + ",1)" : e;
}
function Vt(e) {
  var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, a = e.replace(t, function(M, l, R, C) {
    return l + l + R + R + C + C;
  }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a), o = parseInt(r[1], 16), f = parseInt(r[2], 16), d = parseInt(r[3], 16);
  return "rgba(" + o + "," + f + "," + d + ",1)";
}
function Ut(e) {
  var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e), a = parseInt(t[1], 10) / 360, r = parseInt(t[2], 10) / 100, o = parseInt(t[3], 10) / 100, f = t[4] || 1;
  function d(S, N, D) {
    return D < 0 && (D += 1), D > 1 && (D -= 1), D < 1 / 6 ? S + (N - S) * 6 * D : D < 1 / 2 ? N : D < 2 / 3 ? S + (N - S) * (2 / 3 - D) * 6 : S;
  }
  var M, l, R;
  if (r == 0)
    M = l = R = o;
  else {
    var C = o < 0.5 ? o * (1 + r) : o + r - o * r, w = 2 * o - C;
    M = d(w, C, a + 1 / 3), l = d(w, C, a), R = d(w, C, a - 1 / 3);
  }
  return "rgba(" + M * 255 + "," + l * 255 + "," + R * 255 + "," + f + ")";
}
function Wt(e) {
  if (X.rgb(e))
    return qt(e);
  if (X.hex(e))
    return Vt(e);
  if (X.hsl(e))
    return Ut(e);
}
function ue(e) {
  var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
  if (t)
    return t[1];
}
function Kt(e) {
  if (pe(e, "translate") || e === "perspective")
    return "px";
  if (pe(e, "rotate") || pe(e, "skew"))
    return "deg";
}
function Oe(e, t) {
  return X.fnc(e) ? e(t.target, t.id, t.total) : e;
}
function oe(e, t) {
  return e.getAttribute(t);
}
function Fe(e, t, a) {
  var r = ue(t);
  if (Xe([a, "deg", "rad", "turn"], r))
    return t;
  var o = Ce.CSS[t + a];
  if (!X.und(o))
    return o;
  var f = 100, d = document.createElement(e.tagName), M = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
  M.appendChild(d), d.style.position = "absolute", d.style.width = f + a;
  var l = f / d.offsetWidth;
  M.removeChild(d);
  var R = l * parseFloat(t);
  return Ce.CSS[t + a] = R, R;
}
function ht(e, t, a) {
  if (t in e.style) {
    var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), o = e.style[t] || getComputedStyle(e).getPropertyValue(r) || "0";
    return a ? Fe(e, o, a) : o;
  }
}
function je(e, t) {
  if (X.dom(e) && !X.inp(e) && (!X.nil(oe(e, t)) || X.svg(e) && e[t]))
    return "attribute";
  if (X.dom(e) && Xe(jt, t))
    return "transform";
  if (X.dom(e) && t !== "transform" && ht(e, t))
    return "css";
  if (e[t] != null)
    return "object";
}
function vt(e) {
  if (X.dom(e)) {
    for (var t = e.style.transform || "", a = /(\w+)\(([^)]*)\)/g, r = /* @__PURE__ */ new Map(), o; o = a.exec(t); )
      r.set(o[1], o[2]);
    return r;
  }
}
function Ht(e, t, a, r) {
  var o = pe(t, "scale") ? 1 : 0 + Kt(t), f = vt(e).get(t) || o;
  return a && (a.transforms.list.set(t, f), a.transforms.last = t), r ? Fe(e, f, r) : f;
}
function ze(e, t, a, r) {
  switch (je(e, t)) {
    case "transform":
      return Ht(e, t, r, a);
    case "css":
      return ht(e, t, a);
    case "attribute":
      return oe(e, t);
    default:
      return e[t] || 0;
  }
}
function Ne(e, t) {
  var a = /^(\*=|\+=|-=)/.exec(e);
  if (!a)
    return e;
  var r = ue(e) || 0, o = parseFloat(t), f = parseFloat(e.replace(a[0], ""));
  switch (a[0][0]) {
    case "+":
      return o + f + r;
    case "-":
      return o - f + r;
    case "*":
      return o * f + r;
  }
}
function gt(e, t) {
  if (X.col(e))
    return Wt(e);
  if (/\s/g.test(e))
    return e;
  var a = ue(e), r = a ? e.substr(0, e.length - a.length) : e;
  return t ? r + t : r;
}
function qe(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Gt(e) {
  return Math.PI * 2 * oe(e, "r");
}
function Qt(e) {
  return oe(e, "width") * 2 + oe(e, "height") * 2;
}
function Zt(e) {
  return qe(
    { x: oe(e, "x1"), y: oe(e, "y1") },
    { x: oe(e, "x2"), y: oe(e, "y2") }
  );
}
function mt(e) {
  for (var t = e.points, a = 0, r, o = 0; o < t.numberOfItems; o++) {
    var f = t.getItem(o);
    o > 0 && (a += qe(r, f)), r = f;
  }
  return a;
}
function Jt(e) {
  var t = e.points;
  return mt(e) + qe(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function pt(e) {
  if (e.getTotalLength)
    return e.getTotalLength();
  switch (e.tagName.toLowerCase()) {
    case "circle":
      return Gt(e);
    case "rect":
      return Qt(e);
    case "line":
      return Zt(e);
    case "polyline":
      return mt(e);
    case "polygon":
      return Jt(e);
  }
}
function en(e) {
  var t = pt(e);
  return e.setAttribute("stroke-dasharray", t), t;
}
function tn(e) {
  for (var t = e.parentNode; X.svg(t) && X.svg(t.parentNode); )
    t = t.parentNode;
  return t;
}
function yt(e, t) {
  var a = t || {}, r = a.el || tn(e), o = r.getBoundingClientRect(), f = oe(r, "viewBox"), d = o.width, M = o.height, l = a.viewBox || (f ? f.split(" ") : [0, 0, d, M]);
  return {
    el: r,
    viewBox: l,
    x: l[0] / 1,
    y: l[1] / 1,
    w: d,
    h: M,
    vW: l[2],
    vH: l[3]
  };
}
function nn(e, t) {
  var a = X.str(e) ? dt(e)[0] : e, r = t || 100;
  return function(o) {
    return {
      property: o,
      el: a,
      svg: yt(a),
      totalLength: pt(a) * (r / 100)
    };
  };
}
function rn(e, t, a) {
  function r(C) {
    C === void 0 && (C = 0);
    var w = t + C >= 1 ? t + C : 0;
    return e.el.getPointAtLength(w);
  }
  var o = yt(e.el, e.svg), f = r(), d = r(-1), M = r(1), l = a ? 1 : o.w / o.vW, R = a ? 1 : o.h / o.vH;
  switch (e.property) {
    case "x":
      return (f.x - o.x) * l;
    case "y":
      return (f.y - o.y) * R;
    case "angle":
      return Math.atan2(M.y - d.y, M.x - d.x) * 180 / Math.PI;
  }
}
function Ge(e, t) {
  var a = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = gt(X.pth(e) ? e.totalLength : e, t) + "";
  return {
    original: r,
    numbers: r.match(a) ? r.match(a).map(Number) : [0],
    strings: X.str(e) || t ? r.split(a) : []
  };
}
function Ve(e) {
  var t = e ? Ie(X.arr(e) ? e.map(He) : He(e)) : [];
  return Pe(t, function(a, r, o) {
    return o.indexOf(a) === r;
  });
}
function xt(e) {
  var t = Ve(e);
  return t.map(function(a, r) {
    return { target: a, id: r, total: t.length, transforms: { list: vt(a) } };
  });
}
function an(e, t) {
  var a = $e(t);
  if (/^spring/.test(a.easing) && (a.duration = ct(a.easing)), X.arr(e)) {
    var r = e.length, o = r === 2 && !X.obj(e[0]);
    o ? e = { value: e } : X.fnc(t.duration) || (a.duration = t.duration / r);
  }
  var f = X.arr(e) ? e : [e];
  return f.map(function(d, M) {
    var l = X.obj(d) && !X.pth(d) ? d : { value: d };
    return X.und(l.delay) && (l.delay = M ? 0 : t.delay), X.und(l.endDelay) && (l.endDelay = M === f.length - 1 ? t.endDelay : 0), l;
  }).map(function(d) {
    return Be(d, a);
  });
}
function on(e) {
  for (var t = Pe(Ie(e.map(function(f) {
    return Object.keys(f);
  })), function(f) {
    return X.key(f);
  }).reduce(function(f, d) {
    return f.indexOf(d) < 0 && f.push(d), f;
  }, []), a = {}, r = function(f) {
    var d = t[f];
    a[d] = e.map(function(M) {
      var l = {};
      for (var R in M)
        X.key(R) ? R == d && (l.value = M[R]) : l[R] = M[R];
      return l;
    });
  }, o = 0; o < t.length; o++) r(o);
  return a;
}
function sn(e, t) {
  var a = [], r = t.keyframes;
  r && (t = Be(on(r), t));
  for (var o in t)
    X.key(o) && a.push({
      name: o,
      tweens: an(t[o], e)
    });
  return a;
}
function ln(e, t) {
  var a = {};
  for (var r in e) {
    var o = Oe(e[r], t);
    X.arr(o) && (o = o.map(function(f) {
      return Oe(f, t);
    }), o.length === 1 && (o = o[0])), a[r] = o;
  }
  return a.duration = parseFloat(a.duration), a.delay = parseFloat(a.delay), a;
}
function un(e, t) {
  var a;
  return e.tweens.map(function(r) {
    var o = ln(r, t), f = o.value, d = X.arr(f) ? f[1] : f, M = ue(d), l = ze(t.target, e.name, M, t), R = a ? a.to.original : l, C = X.arr(f) ? f[0] : R, w = ue(C) || ue(l), S = M || w;
    return X.und(d) && (d = R), o.from = Ge(C, S), o.to = Ge(Ne(d, C), S), o.start = a ? a.end : 0, o.end = o.start + o.delay + o.duration + o.endDelay, o.easing = Le(o.easing, o.duration), o.isPath = X.pth(f), o.isPathTargetInsideSVG = o.isPath && X.svg(t.target), o.isColor = X.col(o.from.original), o.isColor && (o.round = 1), a = o, o;
  });
}
var Mt = {
  css: function(e, t, a) {
    return e.style[t] = a;
  },
  attribute: function(e, t, a) {
    return e.setAttribute(t, a);
  },
  object: function(e, t, a) {
    return e[t] = a;
  },
  transform: function(e, t, a, r, o) {
    if (r.list.set(t, a), t === r.last || o) {
      var f = "";
      r.list.forEach(function(d, M) {
        f += M + "(" + d + ") ";
      }), e.style.transform = f;
    }
  }
};
function wt(e, t) {
  var a = xt(e);
  a.forEach(function(r) {
    for (var o in t) {
      var f = Oe(t[o], r), d = r.target, M = ue(f), l = ze(d, o, M, r), R = M || ue(l), C = Ne(gt(f, R), l), w = je(d, o);
      Mt[w](d, o, C, r.transforms, !0);
    }
  });
}
function cn(e, t) {
  var a = je(e.target, t.name);
  if (a) {
    var r = un(t, e), o = r[r.length - 1];
    return {
      type: a,
      property: t.name,
      animatable: e,
      tweens: r,
      duration: o.end,
      delay: r[0].delay,
      endDelay: o.endDelay
    };
  }
}
function fn(e, t) {
  return Pe(Ie(e.map(function(a) {
    return t.map(function(r) {
      return cn(a, r);
    });
  })), function(a) {
    return !X.und(a);
  });
}
function kt(e, t) {
  var a = e.length, r = function(f) {
    return f.timelineOffset ? f.timelineOffset : 0;
  }, o = {};
  return o.duration = a ? Math.max.apply(Math, e.map(function(f) {
    return r(f) + f.duration;
  })) : t.duration, o.delay = a ? Math.min.apply(Math, e.map(function(f) {
    return r(f) + f.delay;
  })) : t.delay, o.endDelay = a ? o.duration - Math.max.apply(Math, e.map(function(f) {
    return r(f) + f.duration - f.endDelay;
  })) : t.endDelay, o;
}
var Qe = 0;
function dn(e) {
  var t = De(lt, e), a = De(Re, e), r = sn(a, e), o = xt(e.targets), f = fn(o, r), d = kt(f, a), M = Qe;
  return Qe++, Be(t, {
    id: M,
    children: [],
    animatables: o,
    animations: f,
    duration: d.duration,
    delay: d.delay,
    endDelay: d.endDelay
  });
}
var re = [], Ct = function() {
  var e;
  function t() {
    !e && (!Ze() || !G.suspendWhenDocumentHidden) && re.length > 0 && (e = requestAnimationFrame(a));
  }
  function a(o) {
    for (var f = re.length, d = 0; d < f; ) {
      var M = re[d];
      M.paused ? (re.splice(d, 1), f--) : (M.tick(o), d++);
    }
    e = d > 0 ? requestAnimationFrame(a) : void 0;
  }
  function r() {
    G.suspendWhenDocumentHidden && (Ze() ? e = cancelAnimationFrame(e) : (re.forEach(
      function(o) {
        return o._onDocumentVisibility();
      }
    ), Ct()));
  }
  return typeof document < "u" && document.addEventListener("visibilitychange", r), t;
}();
function Ze() {
  return !!document && document.hidden;
}
function G(e) {
  e === void 0 && (e = {});
  var t = 0, a = 0, r = 0, o, f = 0, d = null;
  function M(i) {
    var s = window.Promise && new Promise(function(n) {
      return d = n;
    });
    return i.finished = s, s;
  }
  var l = dn(e);
  M(l);
  function R() {
    var i = l.direction;
    i !== "alternate" && (l.direction = i !== "normal" ? "normal" : "reverse"), l.reversed = !l.reversed, o.forEach(function(s) {
      return s.reversed = l.reversed;
    });
  }
  function C(i) {
    return l.reversed ? l.duration - i : i;
  }
  function w() {
    t = 0, a = C(l.currentTime) * (1 / G.speed);
  }
  function S(i, s) {
    s && s.seek(i - s.timelineOffset);
  }
  function N(i) {
    if (l.reversePlayback)
      for (var n = f; n--; )
        S(i, o[n]);
    else
      for (var s = 0; s < f; s++)
        S(i, o[s]);
  }
  function D(i) {
    for (var s = 0, n = l.animations, c = n.length; s < c; ) {
      var u = n[s], h = u.animatable, g = u.tweens, p = g.length - 1, y = g[p];
      p && (y = Pe(g, function($) {
        return i < $.end;
      })[0] || y);
      for (var I = ie(i - y.start - y.delay, 0, y.duration) / y.duration, O = isNaN(I) ? 1 : y.easing(I), m = y.to.strings, v = y.round, B = [], k = y.to.numbers.length, P = void 0, E = 0; E < k; E++) {
        var F = void 0, x = y.to.numbers[E], b = y.from.numbers[E] || 0;
        y.isPath ? F = rn(y.value, O * x, y.isPathTargetInsideSVG) : F = b + O * (x - b), v && (y.isColor && E > 2 || (F = Math.round(F * v) / v)), B.push(F);
      }
      var _ = m.length;
      if (!_)
        P = B[0];
      else {
        P = m[0];
        for (var Y = 0; Y < _; Y++) {
          m[Y];
          var j = m[Y + 1], q = B[Y];
          isNaN(q) || (j ? P += q + j : P += q + " ");
        }
      }
      Mt[u.type](h.target, u.property, P, h.transforms), u.currentValue = P, s++;
    }
  }
  function T(i) {
    l[i] && !l.passThrough && l[i](l);
  }
  function z() {
    l.remaining && l.remaining !== !0 && l.remaining--;
  }
  function W(i) {
    var s = l.duration, n = l.delay, c = s - l.endDelay, u = C(i);
    l.progress = ie(u / s * 100, 0, 100), l.reversePlayback = u < l.currentTime, o && N(u), !l.began && l.currentTime > 0 && (l.began = !0, T("begin")), !l.loopBegan && l.currentTime > 0 && (l.loopBegan = !0, T("loopBegin")), u <= n && l.currentTime !== 0 && D(0), (u >= c && l.currentTime !== s || !s) && D(s), u > n && u < c ? (l.changeBegan || (l.changeBegan = !0, l.changeCompleted = !1, T("changeBegin")), T("change"), D(u)) : l.changeBegan && (l.changeCompleted = !0, l.changeBegan = !1, T("changeComplete")), l.currentTime = ie(u, 0, s), l.began && T("update"), i >= s && (a = 0, z(), l.remaining ? (t = r, T("loopComplete"), l.loopBegan = !1, l.direction === "alternate" && R()) : (l.paused = !0, l.completed || (l.completed = !0, T("loopComplete"), T("complete"), !l.passThrough && "Promise" in window && (d(), M(l)))));
  }
  return l.reset = function() {
    var i = l.direction;
    l.passThrough = !1, l.currentTime = 0, l.progress = 0, l.paused = !0, l.began = !1, l.loopBegan = !1, l.changeBegan = !1, l.completed = !1, l.changeCompleted = !1, l.reversePlayback = !1, l.reversed = i === "reverse", l.remaining = l.loop, o = l.children, f = o.length;
    for (var s = f; s--; )
      l.children[s].reset();
    (l.reversed && l.loop !== !0 || i === "alternate" && l.loop === 1) && l.remaining++, D(l.reversed ? l.duration : 0);
  }, l._onDocumentVisibility = w, l.set = function(i, s) {
    return wt(i, s), l;
  }, l.tick = function(i) {
    r = i, t || (t = r), W((r + (a - t)) * G.speed);
  }, l.seek = function(i) {
    W(C(i));
  }, l.pause = function() {
    l.paused = !0, w();
  }, l.play = function() {
    l.paused && (l.completed && l.reset(), l.paused = !1, re.push(l), w(), Ct());
  }, l.reverse = function() {
    R(), l.completed = !l.reversed, w();
  }, l.restart = function() {
    l.reset(), l.play();
  }, l.remove = function(i) {
    var s = Ve(i);
    Pt(s, l);
  }, l.reset(), l.autoplay && l.play(), l;
}
function Je(e, t) {
  for (var a = t.length; a--; )
    Xe(e, t[a].animatable.target) && t.splice(a, 1);
}
function Pt(e, t) {
  var a = t.animations, r = t.children;
  Je(e, a);
  for (var o = r.length; o--; ) {
    var f = r[o], d = f.animations;
    Je(e, d), !d.length && !f.children.length && r.splice(o, 1);
  }
  !a.length && !r.length && t.pause();
}
function hn(e) {
  for (var t = Ve(e), a = re.length; a--; ) {
    var r = re[a];
    Pt(t, r);
  }
}
function vn(e, t) {
  t === void 0 && (t = {});
  var a = t.direction || "normal", r = t.easing ? Le(t.easing) : null, o = t.grid, f = t.axis, d = t.from || 0, M = d === "first", l = d === "center", R = d === "last", C = X.arr(e), w = parseFloat(C ? e[0] : e), S = C ? parseFloat(e[1]) : 0, N = ue(C ? e[1] : e) || 0, D = t.start || 0 + (C ? w : 0), T = [], z = 0;
  return function(W, i, s) {
    if (M && (d = 0), l && (d = (s - 1) / 2), R && (d = s - 1), !T.length) {
      for (var n = 0; n < s; n++) {
        if (!o)
          T.push(Math.abs(d - n));
        else {
          var c = l ? (o[0] - 1) / 2 : d % o[0], u = l ? (o[1] - 1) / 2 : Math.floor(d / o[0]), h = n % o[0], g = Math.floor(n / o[0]), p = c - h, y = u - g, I = Math.sqrt(p * p + y * y);
          f === "x" && (I = -p), f === "y" && (I = -y), T.push(I);
        }
        z = Math.max.apply(Math, T);
      }
      r && (T = T.map(function(m) {
        return r(m / z) * z;
      })), a === "reverse" && (T = T.map(function(m) {
        return f ? m < 0 ? m * -1 : -m : Math.abs(z - m);
      }));
    }
    var O = C ? (S - w) / z : w;
    return D + O * (Math.round(T[i] * 100) / 100) + N;
  };
}
function gn(e) {
  e === void 0 && (e = {});
  var t = G(e);
  return t.duration = 0, t.add = function(a, r) {
    var o = re.indexOf(t), f = t.children;
    o > -1 && re.splice(o, 1);
    function d(S) {
      S.passThrough = !0;
    }
    for (var M = 0; M < f.length; M++)
      d(f[M]);
    var l = Be(a, De(Re, e));
    l.targets = l.targets || e.targets;
    var R = t.duration;
    l.autoplay = !1, l.direction = t.direction, l.timelineOffset = X.und(r) ? R : Ne(r, R), d(t), t.seek(l.timelineOffset);
    var C = G(l);
    d(C), f.push(C);
    var w = kt(f, e);
    return t.delay = w.delay, t.endDelay = w.endDelay, t.duration = w.duration, t.seek(0), t.reset(), t.autoplay && t.play(), t;
  }, t;
}
G.version = "3.2.1";
G.speed = 1;
G.suspendWhenDocumentHidden = !0;
G.running = re;
G.remove = hn;
G.get = ze;
G.set = wt;
G.convertPx = Fe;
G.path = nn;
G.setDashoffset = en;
G.stagger = vn;
G.timeline = gn;
G.easing = Le;
G.penner = ft;
G.random = function(e, t) {
  return Math.floor(Math.random() * (t - e + 1)) + e;
};
var Jn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function mn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function pn(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var a = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    a.prototype = t.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(a, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), a;
}
var we = { exports: {} }, ke = { exports: {} }, yn = ke.exports, et;
function xn() {
  return et || (et = 1, function(e, t) {
    (function(a, r) {
      e.exports = r();
    })(yn, function() {
      function a(i, s, n, c, u) {
        (function h(g, p, y, I, O) {
          for (; I > y; ) {
            if (I - y > 600) {
              var m = I - y + 1, v = p - y + 1, B = Math.log(m), k = 0.5 * Math.exp(2 * B / 3), P = 0.5 * Math.sqrt(B * k * (m - k) / m) * (v - m / 2 < 0 ? -1 : 1), E = Math.max(y, Math.floor(p - v * k / m + P)), F = Math.min(I, Math.floor(p + (m - v) * k / m + P));
              h(g, p, E, F, O);
            }
            var x = g[p], b = y, _ = I;
            for (r(g, y, p), O(g[I], x) > 0 && r(g, y, I); b < _; ) {
              for (r(g, b, _), b++, _--; O(g[b], x) < 0; ) b++;
              for (; O(g[_], x) > 0; ) _--;
            }
            O(g[y], x) === 0 ? r(g, y, _) : r(g, ++_, I), _ <= p && (y = _ + 1), p <= _ && (I = _ - 1);
          }
        })(i, s, n || 0, c || i.length - 1, u || o);
      }
      function r(i, s, n) {
        var c = i[s];
        i[s] = i[n], i[n] = c;
      }
      function o(i, s) {
        return i < s ? -1 : i > s ? 1 : 0;
      }
      var f = function(i) {
        i === void 0 && (i = 9), this._maxEntries = Math.max(4, i), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
      };
      function d(i, s, n) {
        if (!n) return s.indexOf(i);
        for (var c = 0; c < s.length; c++) if (n(i, s[c])) return c;
        return -1;
      }
      function M(i, s) {
        l(i, 0, i.children.length, s, i);
      }
      function l(i, s, n, c, u) {
        u || (u = z(null)), u.minX = 1 / 0, u.minY = 1 / 0, u.maxX = -1 / 0, u.maxY = -1 / 0;
        for (var h = s; h < n; h++) {
          var g = i.children[h];
          R(u, i.leaf ? c(g) : g);
        }
        return u;
      }
      function R(i, s) {
        return i.minX = Math.min(i.minX, s.minX), i.minY = Math.min(i.minY, s.minY), i.maxX = Math.max(i.maxX, s.maxX), i.maxY = Math.max(i.maxY, s.maxY), i;
      }
      function C(i, s) {
        return i.minX - s.minX;
      }
      function w(i, s) {
        return i.minY - s.minY;
      }
      function S(i) {
        return (i.maxX - i.minX) * (i.maxY - i.minY);
      }
      function N(i) {
        return i.maxX - i.minX + (i.maxY - i.minY);
      }
      function D(i, s) {
        return i.minX <= s.minX && i.minY <= s.minY && s.maxX <= i.maxX && s.maxY <= i.maxY;
      }
      function T(i, s) {
        return s.minX <= i.maxX && s.minY <= i.maxY && s.maxX >= i.minX && s.maxY >= i.minY;
      }
      function z(i) {
        return { children: i, height: 1, leaf: !0, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
      }
      function W(i, s, n, c, u) {
        for (var h = [s, n]; h.length; ) if (!((n = h.pop()) - (s = h.pop()) <= c)) {
          var g = s + Math.ceil((n - s) / c / 2) * c;
          a(i, g, s, n, u), h.push(s, g, g, n);
        }
      }
      return f.prototype.all = function() {
        return this._all(this.data, []);
      }, f.prototype.search = function(i) {
        var s = this.data, n = [];
        if (!T(i, s)) return n;
        for (var c = this.toBBox, u = []; s; ) {
          for (var h = 0; h < s.children.length; h++) {
            var g = s.children[h], p = s.leaf ? c(g) : g;
            T(i, p) && (s.leaf ? n.push(g) : D(i, p) ? this._all(g, n) : u.push(g));
          }
          s = u.pop();
        }
        return n;
      }, f.prototype.collides = function(i) {
        var s = this.data;
        if (!T(i, s)) return !1;
        for (var n = []; s; ) {
          for (var c = 0; c < s.children.length; c++) {
            var u = s.children[c], h = s.leaf ? this.toBBox(u) : u;
            if (T(i, h)) {
              if (s.leaf || D(i, h)) return !0;
              n.push(u);
            }
          }
          s = n.pop();
        }
        return !1;
      }, f.prototype.load = function(i) {
        if (!i || !i.length) return this;
        if (i.length < this._minEntries) {
          for (var s = 0; s < i.length; s++) this.insert(i[s]);
          return this;
        }
        var n = this._build(i.slice(), 0, i.length - 1, 0);
        if (this.data.children.length) if (this.data.height === n.height) this._splitRoot(this.data, n);
        else {
          if (this.data.height < n.height) {
            var c = this.data;
            this.data = n, n = c;
          }
          this._insert(n, this.data.height - n.height - 1, !0);
        }
        else this.data = n;
        return this;
      }, f.prototype.insert = function(i) {
        return i && this._insert(i, this.data.height - 1), this;
      }, f.prototype.clear = function() {
        return this.data = z([]), this;
      }, f.prototype.remove = function(i, s) {
        if (!i) return this;
        for (var n, c, u, h = this.data, g = this.toBBox(i), p = [], y = []; h || p.length; ) {
          if (h || (h = p.pop(), c = p[p.length - 1], n = y.pop(), u = !0), h.leaf) {
            var I = d(i, h.children, s);
            if (I !== -1) return h.children.splice(I, 1), p.push(h), this._condense(p), this;
          }
          u || h.leaf || !D(h, g) ? c ? (n++, h = c.children[n], u = !1) : h = null : (p.push(h), y.push(n), n = 0, c = h, h = h.children[0]);
        }
        return this;
      }, f.prototype.toBBox = function(i) {
        return i;
      }, f.prototype.compareMinX = function(i, s) {
        return i.minX - s.minX;
      }, f.prototype.compareMinY = function(i, s) {
        return i.minY - s.minY;
      }, f.prototype.toJSON = function() {
        return this.data;
      }, f.prototype.fromJSON = function(i) {
        return this.data = i, this;
      }, f.prototype._all = function(i, s) {
        for (var n = []; i; ) i.leaf ? s.push.apply(s, i.children) : n.push.apply(n, i.children), i = n.pop();
        return s;
      }, f.prototype._build = function(i, s, n, c) {
        var u, h = n - s + 1, g = this._maxEntries;
        if (h <= g) return M(u = z(i.slice(s, n + 1)), this.toBBox), u;
        c || (c = Math.ceil(Math.log(h) / Math.log(g)), g = Math.ceil(h / Math.pow(g, c - 1))), (u = z([])).leaf = !1, u.height = c;
        var p = Math.ceil(h / g), y = p * Math.ceil(Math.sqrt(g));
        W(i, s, n, y, this.compareMinX);
        for (var I = s; I <= n; I += y) {
          var O = Math.min(I + y - 1, n);
          W(i, I, O, p, this.compareMinY);
          for (var m = I; m <= O; m += p) {
            var v = Math.min(m + p - 1, O);
            u.children.push(this._build(i, m, v, c - 1));
          }
        }
        return M(u, this.toBBox), u;
      }, f.prototype._chooseSubtree = function(i, s, n, c) {
        for (; c.push(s), !s.leaf && c.length - 1 !== n; ) {
          for (var u = 1 / 0, h = 1 / 0, g = void 0, p = 0; p < s.children.length; p++) {
            var y = s.children[p], I = S(y), O = (m = i, v = y, (Math.max(v.maxX, m.maxX) - Math.min(v.minX, m.minX)) * (Math.max(v.maxY, m.maxY) - Math.min(v.minY, m.minY)) - I);
            O < h ? (h = O, u = I < u ? I : u, g = y) : O === h && I < u && (u = I, g = y);
          }
          s = g || s.children[0];
        }
        var m, v;
        return s;
      }, f.prototype._insert = function(i, s, n) {
        var c = n ? i : this.toBBox(i), u = [], h = this._chooseSubtree(c, this.data, s, u);
        for (h.children.push(i), R(h, c); s >= 0 && u[s].children.length > this._maxEntries; ) this._split(u, s), s--;
        this._adjustParentBBoxes(c, u, s);
      }, f.prototype._split = function(i, s) {
        var n = i[s], c = n.children.length, u = this._minEntries;
        this._chooseSplitAxis(n, u, c);
        var h = this._chooseSplitIndex(n, u, c), g = z(n.children.splice(h, n.children.length - h));
        g.height = n.height, g.leaf = n.leaf, M(n, this.toBBox), M(g, this.toBBox), s ? i[s - 1].children.push(g) : this._splitRoot(n, g);
      }, f.prototype._splitRoot = function(i, s) {
        this.data = z([i, s]), this.data.height = i.height + 1, this.data.leaf = !1, M(this.data, this.toBBox);
      }, f.prototype._chooseSplitIndex = function(i, s, n) {
        for (var c, u, h, g, p, y, I, O = 1 / 0, m = 1 / 0, v = s; v <= n - s; v++) {
          var B = l(i, 0, v, this.toBBox), k = l(i, v, n, this.toBBox), P = (u = B, h = k, g = void 0, p = void 0, y = void 0, I = void 0, g = Math.max(u.minX, h.minX), p = Math.max(u.minY, h.minY), y = Math.min(u.maxX, h.maxX), I = Math.min(u.maxY, h.maxY), Math.max(0, y - g) * Math.max(0, I - p)), E = S(B) + S(k);
          P < O ? (O = P, c = v, m = E < m ? E : m) : P === O && E < m && (m = E, c = v);
        }
        return c || n - s;
      }, f.prototype._chooseSplitAxis = function(i, s, n) {
        var c = i.leaf ? this.compareMinX : C, u = i.leaf ? this.compareMinY : w;
        this._allDistMargin(i, s, n, c) < this._allDistMargin(i, s, n, u) && i.children.sort(c);
      }, f.prototype._allDistMargin = function(i, s, n, c) {
        i.children.sort(c);
        for (var u = this.toBBox, h = l(i, 0, s, u), g = l(i, n - s, n, u), p = N(h) + N(g), y = s; y < n - s; y++) {
          var I = i.children[y];
          R(h, i.leaf ? u(I) : I), p += N(h);
        }
        for (var O = n - s - 1; O >= s; O--) {
          var m = i.children[O];
          R(g, i.leaf ? u(m) : m), p += N(g);
        }
        return p;
      }, f.prototype._adjustParentBBoxes = function(i, s, n) {
        for (var c = n; c >= 0; c--) R(s[c], i);
      }, f.prototype._condense = function(i) {
        for (var s = i.length - 1, n = void 0; s >= 0; s--) i[s].children.length === 0 ? s > 0 ? (n = i[s - 1].children).splice(n.indexOf(i[s]), 1) : this.clear() : M(i[s], this.toBBox);
      }, f;
    });
  }(ke)), ke.exports;
}
class Mn {
  constructor(t = [], a = wn) {
    if (this.data = t, this.length = this.data.length, this.compare = a, this.length > 0)
      for (let r = (this.length >> 1) - 1; r >= 0; r--) this._down(r);
  }
  push(t) {
    this.data.push(t), this.length++, this._up(this.length - 1);
  }
  pop() {
    if (this.length === 0) return;
    const t = this.data[0], a = this.data.pop();
    return this.length--, this.length > 0 && (this.data[0] = a, this._down(0)), t;
  }
  peek() {
    return this.data[0];
  }
  _up(t) {
    const { data: a, compare: r } = this, o = a[t];
    for (; t > 0; ) {
      const f = t - 1 >> 1, d = a[f];
      if (r(o, d) >= 0) break;
      a[t] = d, t = f;
    }
    a[t] = o;
  }
  _down(t) {
    const { data: a, compare: r } = this, o = this.length >> 1, f = a[t];
    for (; t < o; ) {
      let d = (t << 1) + 1, M = a[d];
      const l = d + 1;
      if (l < this.length && r(a[l], M) < 0 && (d = l, M = a[l]), r(M, f) >= 0) break;
      a[t] = M, t = d;
    }
    a[t] = f;
  }
}
function wn(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
const kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mn
}, Symbol.toStringTag, { value: "Module" })), Cn = /* @__PURE__ */ pn(kn);
var ge = { exports: {} }, Te, tt;
function Pn() {
  return tt || (tt = 1, Te = function(t, a, r, o) {
    var f = t[0], d = t[1], M = !1;
    r === void 0 && (r = 0), o === void 0 && (o = a.length);
    for (var l = (o - r) / 2, R = 0, C = l - 1; R < l; C = R++) {
      var w = a[r + R * 2 + 0], S = a[r + R * 2 + 1], N = a[r + C * 2 + 0], D = a[r + C * 2 + 1], T = S > d != D > d && f < (N - w) * (d - S) / (D - S) + w;
      T && (M = !M);
    }
    return M;
  }), Te;
}
var Ae, nt;
function In() {
  return nt || (nt = 1, Ae = function(t, a, r, o) {
    var f = t[0], d = t[1], M = !1;
    r === void 0 && (r = 0), o === void 0 && (o = a.length);
    for (var l = o - r, R = 0, C = l - 1; R < l; C = R++) {
      var w = a[R + r][0], S = a[R + r][1], N = a[C + r][0], D = a[C + r][1], T = S > d != D > d && f < (N - w) * (d - S) / (D - S) + w;
      T && (M = !M);
    }
    return M;
  }), Ae;
}
var rt;
function Bn() {
  if (rt) return ge.exports;
  rt = 1;
  var e = Pn(), t = In();
  return ge.exports = function(r, o, f, d) {
    return o.length > 0 && Array.isArray(o[0]) ? t(r, o, f, d) : e(r, o, f, d);
  }, ge.exports.nested = t, ge.exports.flat = e, ge.exports;
}
var me = { exports: {} }, _n = me.exports, at;
function En() {
  return at || (at = 1, function(e, t) {
    (function(a, r) {
      r(t);
    })(_n, function(a) {
      const o = 33306690738754706e-32;
      function f(T, z, W, i, s) {
        let n, c, u, h, g = z[0], p = i[0], y = 0, I = 0;
        p > g == p > -g ? (n = g, g = z[++y]) : (n = p, p = i[++I]);
        let O = 0;
        if (y < T && I < W) for (p > g == p > -g ? (u = n - ((c = g + n) - g), g = z[++y]) : (u = n - ((c = p + n) - p), p = i[++I]), n = c, u !== 0 && (s[O++] = u); y < T && I < W; ) p > g == p > -g ? (u = n - ((c = n + g) - (h = c - n)) + (g - h), g = z[++y]) : (u = n - ((c = n + p) - (h = c - n)) + (p - h), p = i[++I]), n = c, u !== 0 && (s[O++] = u);
        for (; y < T; ) u = n - ((c = n + g) - (h = c - n)) + (g - h), g = z[++y], n = c, u !== 0 && (s[O++] = u);
        for (; I < W; ) u = n - ((c = n + p) - (h = c - n)) + (p - h), p = i[++I], n = c, u !== 0 && (s[O++] = u);
        return n === 0 && O !== 0 || (s[O++] = n), O;
      }
      function d(T) {
        return new Float64Array(T);
      }
      const M = 33306690738754716e-32, l = 22204460492503146e-32, R = 11093356479670487e-47, C = d(4), w = d(8), S = d(12), N = d(16), D = d(4);
      a.orient2d = function(T, z, W, i, s, n) {
        const c = (z - n) * (W - s), u = (T - s) * (i - n), h = c - u;
        if (c === 0 || u === 0 || c > 0 != u > 0) return h;
        const g = Math.abs(c + u);
        return Math.abs(h) >= M * g ? h : -function(p, y, I, O, m, v, B) {
          let k, P, E, F, x, b, _, Y, j, q, $, V, L, A, U, H, Z, Q;
          const K = p - m, J = I - m, ee = y - v, te = O - v;
          x = (U = (Y = K - (_ = (b = 134217729 * K) - (b - K))) * (q = te - (j = (b = 134217729 * te) - (b - te))) - ((A = K * te) - _ * j - Y * j - _ * q)) - ($ = U - (Z = (Y = ee - (_ = (b = 134217729 * ee) - (b - ee))) * (q = J - (j = (b = 134217729 * J) - (b - J))) - ((H = ee * J) - _ * j - Y * j - _ * q))), C[0] = U - ($ + x) + (x - Z), x = (L = A - ((V = A + $) - (x = V - A)) + ($ - x)) - ($ = L - H), C[1] = L - ($ + x) + (x - H), x = (Q = V + $) - V, C[2] = V - (Q - x) + ($ - x), C[3] = Q;
          let ae = function(_t, Ue) {
            let We = Ue[0];
            for (let Ee = 1; Ee < _t; Ee++) We += Ue[Ee];
            return We;
          }(4, C), se = l * B;
          if (ae >= se || -ae >= se || (k = p - (K + (x = p - K)) + (x - m), E = I - (J + (x = I - J)) + (x - m), P = y - (ee + (x = y - ee)) + (x - v), F = O - (te + (x = O - te)) + (x - v), k === 0 && P === 0 && E === 0 && F === 0) || (se = R * B + o * Math.abs(ae), (ae += K * F + te * k - (ee * E + J * P)) >= se || -ae >= se)) return ae;
          x = (U = (Y = k - (_ = (b = 134217729 * k) - (b - k))) * (q = te - (j = (b = 134217729 * te) - (b - te))) - ((A = k * te) - _ * j - Y * j - _ * q)) - ($ = U - (Z = (Y = P - (_ = (b = 134217729 * P) - (b - P))) * (q = J - (j = (b = 134217729 * J) - (b - J))) - ((H = P * J) - _ * j - Y * j - _ * q))), D[0] = U - ($ + x) + (x - Z), x = (L = A - ((V = A + $) - (x = V - A)) + ($ - x)) - ($ = L - H), D[1] = L - ($ + x) + (x - H), x = (Q = V + $) - V, D[2] = V - (Q - x) + ($ - x), D[3] = Q;
          const _e = f(4, C, 4, D, w);
          x = (U = (Y = K - (_ = (b = 134217729 * K) - (b - K))) * (q = F - (j = (b = 134217729 * F) - (b - F))) - ((A = K * F) - _ * j - Y * j - _ * q)) - ($ = U - (Z = (Y = ee - (_ = (b = 134217729 * ee) - (b - ee))) * (q = E - (j = (b = 134217729 * E) - (b - E))) - ((H = ee * E) - _ * j - Y * j - _ * q))), D[0] = U - ($ + x) + (x - Z), x = (L = A - ((V = A + $) - (x = V - A)) + ($ - x)) - ($ = L - H), D[1] = L - ($ + x) + (x - H), x = (Q = V + $) - V, D[2] = V - (Q - x) + ($ - x), D[3] = Q;
          const It = f(_e, w, 4, D, S);
          x = (U = (Y = k - (_ = (b = 134217729 * k) - (b - k))) * (q = F - (j = (b = 134217729 * F) - (b - F))) - ((A = k * F) - _ * j - Y * j - _ * q)) - ($ = U - (Z = (Y = P - (_ = (b = 134217729 * P) - (b - P))) * (q = E - (j = (b = 134217729 * E) - (b - E))) - ((H = P * E) - _ * j - Y * j - _ * q))), D[0] = U - ($ + x) + (x - Z), x = (L = A - ((V = A + $) - (x = V - A)) + ($ - x)) - ($ = L - H), D[1] = L - ($ + x) + (x - H), x = (Q = V + $) - V, D[2] = V - (Q - x) + ($ - x), D[3] = Q;
          const Bt = f(It, S, 4, D, N);
          return N[Bt - 1];
        }(T, z, W, i, s, n, g);
      }, a.orient2dfast = function(T, z, W, i, s, n) {
        return (z - n) * (W - s) - (T - s) * (i - n);
      }, Object.defineProperty(a, "__esModule", { value: !0 });
    });
  }(me, me.exports)), me.exports;
}
var it;
function bn() {
  if (it) return we.exports;
  it = 1;
  var e = xn(), t = Cn, a = Bn(), r = En().orient2d;
  t.default && (t = t.default), we.exports = o, we.exports.default = o;
  function o(n, c, u) {
    c = Math.max(0, c === void 0 ? 2 : c), u = u || 0;
    var h = N(n), g = new e(16);
    g.toBBox = function(_) {
      return {
        minX: _[0],
        minY: _[1],
        maxX: _[0],
        maxY: _[1]
      };
    }, g.compareMinX = function(_, Y) {
      return _[0] - Y[0];
    }, g.compareMinY = function(_, Y) {
      return _[1] - Y[1];
    }, g.load(n);
    for (var p = [], y = 0, I; y < h.length; y++) {
      var O = h[y];
      g.remove(O), I = D(O, I), p.push(I);
    }
    var m = new e(16);
    for (y = 0; y < p.length; y++) m.insert(S(p[y]));
    for (var v = c * c, B = u * u; p.length; ) {
      var k = p.shift(), P = k.p, E = k.next.p, F = T(P, E);
      if (!(F < B)) {
        var x = F / v;
        O = f(g, k.prev.p, P, E, k.next.next.p, x, m), O && Math.min(T(O, P), T(O, E)) <= x && (p.push(k), p.push(D(O, k)), g.remove(O), m.remove(k), m.insert(S(k)), m.insert(S(k.next)));
      }
    }
    k = I;
    var b = [];
    do
      b.push(k.p), k = k.next;
    while (k !== I);
    return b.push(k.p), b;
  }
  function f(n, c, u, h, g, p, y) {
    for (var I = new t([], d), O = n.data; O; ) {
      for (var m = 0; m < O.children.length; m++) {
        var v = O.children[m], B = O.leaf ? z(v, u, h) : M(u, h, v);
        B > p || I.push({
          node: v,
          dist: B
        });
      }
      for (; I.length && !I.peek().node.children; ) {
        var k = I.pop(), P = k.node, E = z(P, c, u), F = z(P, h, g);
        if (k.dist < E && k.dist < F && R(u, P, y) && R(h, P, y)) return P;
      }
      O = I.pop(), O && (O = O.node);
    }
    return null;
  }
  function d(n, c) {
    return n.dist - c.dist;
  }
  function M(n, c, u) {
    if (l(n, u) || l(c, u)) return 0;
    var h = W(n[0], n[1], c[0], c[1], u.minX, u.minY, u.maxX, u.minY);
    if (h === 0) return 0;
    var g = W(n[0], n[1], c[0], c[1], u.minX, u.minY, u.minX, u.maxY);
    if (g === 0) return 0;
    var p = W(n[0], n[1], c[0], c[1], u.maxX, u.minY, u.maxX, u.maxY);
    if (p === 0) return 0;
    var y = W(n[0], n[1], c[0], c[1], u.minX, u.maxY, u.maxX, u.maxY);
    return y === 0 ? 0 : Math.min(h, g, p, y);
  }
  function l(n, c) {
    return n[0] >= c.minX && n[0] <= c.maxX && n[1] >= c.minY && n[1] <= c.maxY;
  }
  function R(n, c, u) {
    for (var h = Math.min(n[0], c[0]), g = Math.min(n[1], c[1]), p = Math.max(n[0], c[0]), y = Math.max(n[1], c[1]), I = u.search({ minX: h, minY: g, maxX: p, maxY: y }), O = 0; O < I.length; O++)
      if (w(I[O].p, I[O].next.p, n, c)) return !1;
    return !0;
  }
  function C(n, c, u) {
    return r(n[0], n[1], c[0], c[1], u[0], u[1]);
  }
  function w(n, c, u, h) {
    return n !== h && c !== u && C(n, c, u) > 0 != C(n, c, h) > 0 && C(u, h, n) > 0 != C(u, h, c) > 0;
  }
  function S(n) {
    var c = n.p, u = n.next.p;
    return n.minX = Math.min(c[0], u[0]), n.minY = Math.min(c[1], u[1]), n.maxX = Math.max(c[0], u[0]), n.maxY = Math.max(c[1], u[1]), n;
  }
  function N(n) {
    for (var c = n[0], u = n[0], h = n[0], g = n[0], p = 0; p < n.length; p++) {
      var y = n[p];
      y[0] < c[0] && (c = y), y[0] > h[0] && (h = y), y[1] < u[1] && (u = y), y[1] > g[1] && (g = y);
    }
    var I = [c, u, h, g], O = I.slice();
    for (p = 0; p < n.length; p++)
      a(n[p], I) || O.push(n[p]);
    return s(O);
  }
  function D(n, c) {
    var u = {
      p: n,
      prev: null,
      next: null,
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0
    };
    return c ? (u.next = c.next, u.prev = c, c.next.prev = u, c.next = u) : (u.prev = u, u.next = u), u;
  }
  function T(n, c) {
    var u = n[0] - c[0], h = n[1] - c[1];
    return u * u + h * h;
  }
  function z(n, c, u) {
    var h = c[0], g = c[1], p = u[0] - h, y = u[1] - g;
    if (p !== 0 || y !== 0) {
      var I = ((n[0] - h) * p + (n[1] - g) * y) / (p * p + y * y);
      I > 1 ? (h = u[0], g = u[1]) : I > 0 && (h += p * I, g += y * I);
    }
    return p = n[0] - h, y = n[1] - g, p * p + y * y;
  }
  function W(n, c, u, h, g, p, y, I) {
    var O = u - n, m = h - c, v = y - g, B = I - p, k = n - g, P = c - p, E = O * O + m * m, F = O * v + m * B, x = v * v + B * B, b = O * k + m * P, _ = v * k + B * P, Y = E * x - F * F, j, q, $, V, L = Y, A = Y;
    Y === 0 ? (q = 0, L = 1, V = _, A = x) : (q = F * _ - x * b, V = E * _ - F * b, q < 0 ? (q = 0, V = _, A = x) : q > L && (q = L, V = _ + F, A = x)), V < 0 ? (V = 0, -b < 0 ? q = 0 : -b > E ? q = L : (q = -b, L = E)) : V > A && (V = A, -b + F < 0 ? q = 0 : -b + F > E ? q = L : (q = -b + F, L = E)), j = q === 0 ? 0 : q / L, $ = V === 0 ? 0 : V / A;
    var U = (1 - j) * n + j * u, H = (1 - j) * c + j * h, Z = (1 - $) * g + $ * y, Q = (1 - $) * p + $ * I, K = Z - U, J = Q - H;
    return K * K + J * J;
  }
  function i(n, c) {
    return n[0] === c[0] ? n[1] - c[1] : n[0] - c[0];
  }
  function s(n) {
    n.sort(i);
    for (var c = [], u = 0; u < n.length; u++) {
      for (; c.length >= 2 && C(c[c.length - 2], c[c.length - 1], n[u]) <= 0; )
        c.pop();
      c.push(n[u]);
    }
    for (var h = [], g = n.length - 1; g >= 0; g--) {
      for (; h.length >= 2 && C(h[h.length - 2], h[h.length - 1], n[g]) <= 0; )
        h.pop();
      h.push(n[g]);
    }
    return h.pop(), c.pop(), c.concat(h);
  }
  return we.exports;
}
var Tn = bn();
const An = /* @__PURE__ */ mn(Tn), Dn = Se({
  name: "vs-map-google",
  components: {
    vsButton: Rt
  },
  props: {
    center: {
      type: Object,
      default: () => ({})
    },
    limit: {
      type: Object,
      default: null
    },
    geofences: {
      type: Object,
      default: () => {
      }
    },
    paths: {
      type: Array,
      default: () => []
    },
    markers: {
      type: Array,
      default: () => []
    },
    clusters: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    polygons: {
      type: Array,
      default: () => []
    },
    forcedFollowedAsset: {
      type: Object,
      default: () => ({})
    },
    stepTime: {
      type: Number,
      default: 100
    },
    lookup: {
      type: Boolean,
      default: !1
    },
    trafficEnabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "ROADMAP"
    },
    locationPermission: {
      type: Boolean,
      default: !0
    },
    toggleBoundaries: {
      type: Boolean,
      default: !1
    },
    flyTo: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["map:loaded", "map:move", "followedAsset:stop", "location:confirm", "ready", "click", "marker:drag", "marker:infoClick", "marker:click"],
  setup(e, { emit: t, expose: a }) {
    const r = le({}), o = le(!0);
    navigator.geolocation && e.locationPermission && navigator.geolocation.getCurrentPosition(async (m) => {
      r.value = {
        lat: m.coords.latitude,
        lng: m.coords.longitude
      };
    });
    const f = ye(() => e.paths.filter((m) => {
      var v;
      return ((v = m.polyLines) == null ? void 0 : v.length) > 0;
    }).map((m) => ({
      geodesic: !0,
      color: m.color,
      opacity: 0.1,
      width: 5,
      points: m.polyLines.map((v) => ({ lng: v[0], lat: v[1] }))
    }))), d = (m) => new Promise((v) => setTimeout(v, m));
    function M(m, v, B, k, P, E) {
      m.beginPath(), m.moveTo(v + E, B), m.lineTo(v + k - E, B), m.quadraticCurveTo(v + k, B, v + k, B + E), m.lineTo(v + k, B + P - E), m.quadraticCurveTo(
        v + k,
        B + P,
        v + k - E,
        B + P
      ), m.lineTo(v + E, B + P), m.quadraticCurveTo(v, B + P, v, B + P - E), m.lineTo(v, B + E), m.quadraticCurveTo(v, B, v + E, B), m.closePath();
    }
    const l = (m, v, B, k, P) => {
      const E = document.createElement("canvas"), F = k ? 20 : 0, x = k ? k.length * 16 : 0, b = P ? 1 : window.devicePixelRatio || 1, _ = v * b / 25;
      E.width = (v + x) * b + _ * 2, E.height = (v + F) * b + _ * 2 + 8, E.style.width = `${E.width}px`, E.style.height = `${E.height}px`;
      const Y = E.getContext("2d");
      if (!Y) return "";
      if (Y.setTransform(b, 0, 0, b, 0, 0), Y.beginPath(), Y.arc((v + x + _) / 2, (v + _) / 2, v / 2, 0, 2 * Math.PI), Y.fillStyle = m, Y.fill(), Y.lineWidth = _, Y.strokeStyle = "white", Y.stroke(), B && (Y.fillStyle = "white", Y.textAlign = "center", Y.font = `${v / 2}px Arial`, Y.fillText(B, (v + x) / 2, v / 2 * 1.3)), k) {
        Y.font = `600 ${v * 0.5}px Montserrat, Arial, sans-serif`, Y.textAlign = "center";
        const j = Y.measureText(k);
        let q = j.width, $ = j.actualBoundingBoxAscent + j.actualBoundingBoxDescent + 4;
        $ || ($ = 16);
        const V = q * 0.1 + 4, L = 4, A = (v + x) / 2 - q / 2 - V, U = v * 1.15, H = q + V * 2, Z = $ + L * 2, Q = 8;
        Y.fillStyle = "white", M(
          Y,
          A,
          U,
          H,
          Z,
          Q
        ), Y.fill();
        const K = (v + x) / 2, J = U + Z / 2 + $ / 4;
        Y.fillStyle = "#282a43", Y.fillText(k.toUpperCase(), K, J);
      }
      return E.toDataURL();
    }, R = async (m, v, B) => {
      const k = document.createElement("canvas"), P = B ? 18 : 0, E = B ? 160 : 0, F = v.height + P, x = Math.max(v.width, E), b = 1;
      k.width = x * b, k.height = F * b, k.style.width = `${x}px`, k.style.height = `${F}px`;
      const _ = k.getContext("2d");
      _.scale(b, b);
      const Y = new Image();
      return await new Promise((j) => {
        Y.onload = j, Y.src = m;
      }), _.drawImage(Y, (x - v.width) / 2, 0, v.width, v.height), B && (_.fillStyle = "black", _.textAlign = "center", _.font = "600 16px Montserrat, Arial, sans-serif", _.lineWidth = 5, _.strokeStyle = "white", _.strokeText(B.substr(0, 32), x / 2, v.height + 10, E), _.fillText(B.substr(0, 32), x / 2, v.height + 10, E), _.lineWidth = 1), {
        url: k.toDataURL(),
        size: {
          width: x,
          height: F
        }
      };
    }, C = ye(() => e.clusters.map((v) => v.assets.map((B, k) => {
      const P = B.name.length ? B.name.length * 16 : 0, E = (B.name.length, 0);
      return {
        id: v.id + k,
        position: {
          lat: B.coordinates[1],
          lng: B.coordinates[0]
        },
        color: v.color,
        icon: {
          url: l(`${v.color}CC`, 28, null, B.name, !0),
          anchor: [(28 + P) / 2, (28 + E) / 2]
        }
      };
    })));
    let w = {}, S = ye(() => {
      const m = e.markers.map((P) => ({
        lat: P.coordinates[1],
        lng: P.coordinates[0]
      })), v = e.events.map((P) => ({
        lat: P.coordinates[1],
        lng: P.coordinates[0]
      })), B = e.clusters.map((P) => P.assets.map((E) => ({
        lat: E.coordinates[1],
        lng: E.coordinates[0]
      }))).flat().filter((P) => P.lat && P.lng), k = f.value.map((P) => P.points);
      return [
        ...m,
        ...v,
        ...k.flat(),
        ...B
      ].filter((P) => P.lat && P.lng);
    });
    const N = /* @__PURE__ */ new Map(), D = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Map();
    async function z(m) {
      const { id: v, name: B, coordinates: k, heading: P, html: E, title: F, size: x, draggable: b, anchor: _, bounce: Y, circle: j, zIndex: q } = m, $ = await R(E, x, B || null), V = await w.addMarker({
        position: {
          lat: k[1],
          lng: k[0]
        },
        icon: {
          url: $.url,
          // Update the anchor and size to match the actual icon dimensions
          anchor: _ || {
            x: $.size.width / 2,
            y: x.height / 2
            // Anchor at the center of the image, not the entire icon
          },
          size: $.size
        },
        draggable: b,
        title: F,
        zIndex: q || 1,
        animation: Y ? plugin.google.maps.Animation.BOUNCE : ""
      });
      if (N.set(v, V), V.on(plugin.google.maps.event.MARKER_CLICK, () => {
        t("marker:click", { id: v });
      }), V.addEventListener(plugin.google.maps.event.MARKER_DRAG_END, (L) => {
        t("marker:drag", { id: v, position: L });
      }), j) {
        const L = await w.addCircle({
          center: N.get(v).getPosition(),
          radius: j.radius,
          fillColor: j.fillColor,
          strokeColor: j.strokeColor,
          strokeWidth: 1
        });
        D.set(v, L), N.get(v).bindTo("position", D.get(v), "center");
      }
    }
    async function W(m) {
      const { id: v, name: B, coordinates: k, html: P, size: E } = m, F = N.get(m.id);
      if (F) {
        const b = await R(P, E, B || null);
        F.setIcon({
          url: b.url,
          // Update the anchor and size to match the actual icon dimensions
          anchor: {
            x: b.size.width / 2,
            y: E.height / 2
            // Anchor at the center of the image, not the entire icon
          },
          size: b.size
        });
      }
      const x = JSON.parse(N.get(v).getPosition());
      G({
        targets: x,
        lat: k[1],
        lng: k[0],
        round: 1e5,
        duration: 400,
        easing: "linear",
        update: function() {
          N.get(v) && N.get(v).setPosition(x);
        }
      });
    }
    async function i(m) {
      const v = N.get(m), B = D.get(m);
      v ? (await v.remove(), N.delete(m)) : console.warn(`Intento de eliminar un marcador no existente con id: ${m}`), B ? (await B.remove(), D.delete(m)) : console.warn(`Intento de eliminar un círculo no existente con id: ${m}`);
    }
    const s = le(!1), n = le(), c = le(!1), u = (m) => {
      const v = m.map((k) => [k.lng, k.lat]);
      let B = m;
      return v.length && (B = An(v, 1)), B.map((k) => ({ lng: k[0], lat: k[1] }));
    }, h = (m) => {
      if (m.length < 3 || !n.value || !m) return !1;
      const v = u(m);
      var B = de.point([n.value.lng, n.value.lat]);
      const k = v.map((E) => [E.lng, E.lat]);
      k.push(k[0]);
      var P = de.polygon([k]);
      return de.booleanPointInPolygon(B, P);
    }, g = ye(() => {
      var m, v;
      return (m = e.geofences) != null && m.length ? (v = e.geofences) == null ? void 0 : v.map((B) => {
        var P;
        const k = (P = B.geometryData) == null ? void 0 : P.points.map((E, F) => ({
          ...E,
          header: " ",
          id: Lt()
        }));
        return h(k);
      }).some((B) => B) : !0;
    }), p = () => {
      var m, v, B, k, P;
      if ((m = e.geofences) != null && m.length && !g.value) {
        c.value = !0;
        return;
      }
      if ((B = (v = e.limit) == null ? void 0 : v.point) != null && B.lat && ((P = (k = e.limit) == null ? void 0 : k.point) != null && P.lng) && n.value) {
        const E = de.point([n.value.lng, n.value.lat]), F = de.point([e.limit.point.lng, e.limit.point.lat]);
        if (de.distance(E, F) > e.limit.distance) {
          c.value = !0;
          return;
        }
      }
      t("location:confirm", n.value);
    }, y = Et(null), I = le(!1);
    return ot(async () => {
      document.addEventListener("deviceready", async () => {
        var m = document.getElementById("map_canvas");
        plugin.google.maps.environment.setEnv({
          API_KEY_FOR_BROWSER_RELEASE: "AIzaSyDDtmcTqrihzaWY6BPyaZDKKu7jQm51Gbg",
          API_KEY_FOR_BROWSER_DEBUG: "AIzaSyDDtmcTqrihzaWY6BPyaZDKKu7jQm51Gbg"
        }), await d(0), w = plugin.google.maps.Map.getMap(m, {
          controls: {
            compass: !1,
            tilt: !1,
            rotate: !1,
            zoom: !1
          }
        }), y.value = w, console.info("first target");
        const v = S.value.length ? S.value.length === 1 ? S.value[0] : S.value : {
          lat: e.center.lat || xe(r.value.lat) || 6.1540293,
          lng: e.center.lng || xe(r.value.lng) || -75.5327601
        };
        w.moveCamera({
          target: v,
          zoom: 16
        }), w.on(plugin.google.maps.event.MAP_CLICK, function(B) {
          t("click", B);
        }), w.on(plugin.google.maps.event.POI_CLICK, function(B, k, P) {
          t("click", P);
        }), w.one(plugin.google.maps.event.MAP_READY, async () => {
          I.value = !0, t("ready", y), w.on(plugin.google.maps.event.CAMERA_MOVE_END, async () => {
            t("map:move"), s.value = !1, e.lookup && (n.value = w.getCameraTarget(), o.value = !1, n.value.lat === r.value.lat && n.value.lng === r.value.lng && (o.value = !0));
          }), w.on(plugin.google.maps.event.CAMERA_MOVE_START, async () => {
            c.value = !1, s.value = !0;
          });
          let B = [];
          const k = (L) => {
            B.forEach((A) => {
              A.remove();
            }), B = [], f.value.forEach((A) => {
              A.points.length > 0 && B.push(w.addPolyline(A));
            });
          };
          ne(() => e.trafficEnabled, () => {
            !w || !I.value || w.setTrafficEnabled(e.trafficEnabled);
          }, { immediate: !0 }), ne(() => e.type, () => {
            w.setMapTypeId(plugin.google.maps.MapTypeId[["ROADMAP", "SATELLITE", "HYBRID", "TERRAIN", "NONE"].includes(e.type) ? e.type : "ROADMAP"]);
          }, { immediate: !0 }), ne(() => e.toggleBoundaries, () => {
            if (!w) return;
            const L = S.value.length ? S.value.length === 1 ? S.value[0] : S.value : {
              lat: e.center.lat || xe(r.value.lat) || 6.1540293,
              lng: e.center.lng || xe(r.value.lng) || -75.5327601
            };
            w.moveCamera({
              target: L,
              zoom: 16
            });
          }), ne(() => e.flyTo, () => {
            w && e.flyTo && w.moveCamera({
              target: e.flyTo,
              zoom: 16
            });
          }), ne(() => e.center, () => {
            e.center.lat && w.moveCamera({
              target: e.center,
              zoom: 16
            });
          }, { immediate: !0 });
          const P = (L) => {
            const { id: A, coordinates: U, draggable: H, title: Z, color: Q, size: K, text: J, movedFrom: ee, zIndex: te } = L, ae = l(Q, K, J);
            if (x[A] = w.addMarker({
              position: {
                lat: U[1],
                lng: U[0]
              },
              draggable: H,
              title: Z,
              zIndex: te || 1,
              icon: {
                url: ae,
                ...K && { size: { width: K, height: K } },
                ...K && { anchor: [K / 2, K / 2] }
              }
            }), ee) {
              const se = A + "_originated", _e = l("#000000", K, J);
              x[se] = w.addMarker({
                position: {
                  lat: ee[1],
                  lng: ee[0]
                },
                draggable: !1,
                title: Z,
                icon: {
                  url: _e,
                  ...K && { size: { width: K, height: K } },
                  ...K && { anchor: [K / 2, K / 2] }
                }
              }), b.value.push(w.addPolyline({
                points: [
                  { lat: U[1], lng: U[0] },
                  { lat: ee[1], lng: ee[0] }
                ],
                color: "#000000",
                width: 1
              }));
            }
            x[A].addEventListener(plugin.google.maps.event.MARKER_DRAG_END, (se) => {
              t("marker:drag", { id: A, position: se });
            }), x[A].on(plugin.google.maps.event.INFO_CLICK, () => {
              t("marker:infoClick", { id: A });
            });
          }, E = (L) => {
            const { id: A, points: U, color: H } = L;
            _[A] = w.addPolygon({
              points: U,
              strokeColor: H,
              strokeWidth: 5,
              fillColor: `${H}55`
            });
          }, F = (L) => {
            var H, Z;
            const A = {
              bold: !1,
              fontSize: 15,
              color: "white"
            }, U = L[0].id.replace("0", "");
            if (!T.has(U)) {
              const Q = w.addMarkerCluster({
                // debug: true,
                boundsDraw: !1,
                markers: L,
                icons: [
                  { min: 2, max: 3, url: l(`${(H = L[0]) == null ? void 0 : H.color}CC`, 32), anchor: { x: 16, y: 16 }, size: { width: 32, height: 32 }, label: A },
                  { min: 3, url: l(`${(Z = L[0]) == null ? void 0 : Z.color}CC`, 48), anchor: { x: 24, y: 24 }, size: { width: 48, height: 48 }, label: A }
                ]
              });
              T.set(U, Q);
            }
          };
          ne(() => e.paths, () => {
            k(e.paths);
          }, { deep: !0, immediate: !0 });
          let x = {};
          const b = le([]);
          ne(() => e.events, async () => {
            const L = Object.keys(x);
            for (const A of b.value)
              A.remove();
            b.value = [];
            for (const A of e.events)
              L.indexOf(A.id) === -1 ? P(A) : (x[A.id].lng !== A.coordinates[0] || x[A.id].lat !== A.coordinates[1]) && (x[A.id].remove(), delete x[A.id], P(A));
            for (const A of L)
              e.events.findIndex((U) => U.id === A) === -1 && (x[A].remove(), delete x[A]);
          }, { deep: !0, immediate: !0 });
          let _ = {};
          ne(() => e.polygons, async () => {
            const L = Object.keys(_);
            for (const A of e.polygons)
              L.indexOf(A.id) !== -1 && (_[A.id].remove(), delete _[A.id]), E(A);
            for (const A of L)
              e.polygons.findIndex((U) => U.id === A) === -1 && (_[A].remove(), delete _[A]);
          }, { deep: !0, immediate: !0 }), ne(() => C.value, async () => {
            for (const [L, A] of T)
              A.remove(), T.delete(L);
            for (const L of C.value)
              F(L);
          }, { deep: !0, immediate: !0 });
          let Y = !1;
          const j = le(Date.now()), q = Xt(j, 100), $ = le(null), { markers: V } = bt(e);
          ne(
            V,
            (L, A) => {
              j.value = Date.now();
            }
          ), ne(
            q,
            async () => {
              for ($.value || ($.value = []); Y; )
                console.info("is updating markers"), await new Promise((L) => setTimeout(L, 100));
              Y = !0;
              try {
                const L = new Map(V.value.map((U) => [U.id, U])), A = new Map($.value.map((U) => [U.id, U]));
                for (const [U, H] of L)
                  N.has(U) ? await W(H) : await z(H);
                for (const [U] of A)
                  L.has(U) || await i(U);
              } finally {
                $.value = V.value, Y = !1;
              }
            },
            { immediate: !0 }
          );
        });
      }, !1);
    }), Tt(() => {
      w.remove();
    }), { centeredOnUserLocation: o, location: n, locationIsContainedInGeofences: g, locationMarker: Ft, emitLocation: p, limitError: c, mapIsMoving: s, useUserLocation: () => {
      n.value = r.value, w.setCameraTarget(n.value), w.setCameraZoom(17);
    } };
  }
}), On = { class: "w-full h-full flex flex-col" }, Sn = {
  key: 0,
  class: "text-center pointer-events-none px-5 text-2xl pb-2 font-bold"
}, Yn = { class: "relative w-full flex-grow border" }, Rn = ["data"], Ln = {
  key: 1,
  class: "bg-surface shadow rounded-xl text-error absolute bottom-8 right-0 left-0 mx-auto z-10 w-60 p-2 text-center font-bold"
}, Xn = { class: "flex justify-end w-full" };
function $n(e, t, a, r, o, f) {
  var M;
  const d = At("vs-button");
  return ce(), he("div", On, [
    e.title !== "" ? (ce(), he("div", Sn, Ke(e.title), 1)) : ve("", !0),
    fe("div", Yn, [
      e.lookup ? (ce(), he("div", {
        key: 0,
        type: "image/svg+xml",
        data: e.locationMarker,
        class: Me([`${e.mapIsMoving ? "!translate-y-[calc(-100%-25px)]" : ""} ${e.limitError || !e.locationIsContainedInGeofences ? "text-error" : ""}`, "transition duration-500 absolute top-1/2 left-1/2 -translate-y-full z-50 -translate-x-1/2 pointer-events-none"])
      }, t[0] || (t[0] = [
        fe("svg", {
          width: "30",
          height: "55",
          viewBox: "0 0 30 55",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          fe("circle", {
            cx: "15",
            cy: "15",
            r: "15",
            fill: "currentColor"
          }),
          fe("circle", {
            cx: "15",
            cy: "15",
            r: "5",
            fill: "white"
          }),
          fe("line", {
            x1: "15",
            y1: "30",
            x2: "15",
            y2: "55",
            stroke: "currentColor",
            "stroke-width": "2"
          })
        ], -1)
      ]), 10, Rn)) : ve("", !0),
      e.limitError || !e.locationIsContainedInGeofences ? (ce(), he("div", Ln, Ke(((M = e.limit) == null ? void 0 : M.errorMessage) || "Esta ubicación no tiene cobertura"), 1)) : ve("", !0),
      e.lookup && e.location ? (ce(), he("div", {
        key: 2,
        class: Me([e.mapIsMoving ? "" : "scale-0", "transition w-1 h-1 duration-500 rounded-full bg-black absolute top-1/2 left-1/2 -translate-y-full z-50 -translate-x-1/2"])
      }, null, 2)) : ve("", !0),
      fe("div", {
        id: "map_canvas",
        class: Me(["w-full h-full min-h-[100px] min-w-[200px]", e.lookup ? "rounded-xl" : ""])
      }, null, 2),
      Dt(d, {
        class: Me([e.centeredOnUserLocation ? "scale-0" : "", "transition duration-300 absolute bottom-4 left-2 !p-1 flex justify-center my-3 !rounded-full h-12 w-12 flex-shrink-0 border-black/20 shadow-lg border"]),
        kind: "surface",
        iconName: "fa6-solid:location-crosshairs",
        onClick: e.useUserLocation
      }, null, 8, ["class", "onClick"])
    ]),
    fe("div", Xn, [
      e.lookup ? (ce(), st(d, {
        key: 0,
        disabled: e.limitError || !e.locationIsContainedInGeofences,
        class: "!text-lg text-center max-w-lg my-1 mt-3",
        onClick: e.emitLocation
      }, {
        default: Ot(() => t[1] || (t[1] = [
          St(" Confirmar dirección ")
        ])),
        _: 1
      }, 8, ["disabled", "onClick"])) : ve("", !0)
    ])
  ]);
}
const Fn = /* @__PURE__ */ Ye(Dn, [["render", $n]]), jn = Se({
  name: "vs-map-libre",
  setup() {
    return ot(() => {
      const e = new $t.Map({
        container: "map",
        // container id
        style: "https://tiles.openfreemap.org/styles/liberty",
        // style: `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${basemapEnum}?token=${accessToken}`,
        center: [-75.5327601, 6.1540293],
        zoom: 15.5,
        // starting position [lng, lat]
        pitch: 0
      });
      e.on("load", function() {
        const t = e.getStyle().layers;
        console.info(t);
      });
    }), {};
  }
}), zn = {
  id: "map",
  style: { width: "100%", height: "500px" }
};
function Nn(e, t, a, r, o, f) {
  return ce(), he("div", zn);
}
const qn = /* @__PURE__ */ Ye(jn, [["render", Nn]]), Vn = Se({
  name: "vs-map",
  components: {
    vsMapGoogle: Fn,
    vsMapLibre: qn
  },
  props: {
    currentMap: {
      type: String,
      default: "vs-map-google"
    },
    paths: {
      type: Array,
      default: () => []
    },
    markers: {
      type: Array,
      default: () => []
    },
    clusters: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    forcedFollowedAsset: {
      type: Object,
      default: () => ({})
    },
    stepTime: {
      type: Number,
      default: 100
    },
    trafficEnabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "ROADMAP"
    },
    locationPermission: {
      type: Boolean,
      default: !0
    },
    toggleBoundaries: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["map:loaded", "followedAsset:stop"],
  setup(e, { emit: t, expose: a }) {
    return {};
  }
});
function Un(e, t, a, r, o, f) {
  return ce(), st(Yt(e.currentMap), {
    paths: e.paths,
    markers: e.markers,
    events: e.events,
    trafficEnabled: e.trafficEnabled,
    type: e.type,
    locationPermission: e.locationPermission,
    toggleBoundaries: e.toggleBoundaries,
    clusters: e.clusters,
    forcedFollowedAsset: e.forcedFollowedAsset,
    stepTime: e.stepTime
  }, null, 8, ["paths", "markers", "events", "trafficEnabled", "type", "locationPermission", "toggleBoundaries", "clusters", "forcedFollowedAsset", "stepTime"]);
}
const er = /* @__PURE__ */ Ye(Vn, [["render", Un]]);
export {
  Jn as c,
  er as v
};
//# sourceMappingURL=vsMap-BIzM7EoO.mjs.map
